<div class="col-12">
  <div class="col-12">
    <!-- メモボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="parentOpenMemoModal">
      {{ $t('message.button_vehicle_dtc_note_modal') }}
    </b-button>
    <b-button v-if="testModeVisible" class="ml-2 mt-2" variant="primary" size="sm" @click="debugExport">
      Export Permanent Data
    </b-button>
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
  </div>
  <div class="col-12">
    <custom-table class="mt-2 ml-2" type="simple" useSort useStripeStyle rowSelect hasTabs currentSortkey="status"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns" @rowButtonClicked="openFFDModal">
      <template v-slot:rowButton>
        <img class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
      </template>
    </custom-table>
  </div>

  <!-- FFD 一覧画面 -->
  <b-modal v-model="modalFfd" size="huge" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <!-- FFDタイトルの設定 -->
    <template v-slot:header>
      <div class="text-center w-100">
        {{ ffdTitle }}
      </div>
    </template>

    <ffd-modal v-if="modalFfd" :ffdTableProp="ffdSystemTable" :systemProp="selectedSystem" :ffdSystem="ffdSystem"
      :ffdDescription="ffdDescription" :isObd="isObd" :dataPlayback="dataPlayback" :dataName="measuredDataName"
      ref="ffd_modal">
      <template v-slot:didTestBtn>
        <b-button v-if="testModeVisible" class="clear-button" variant="primary" size="sm" @click="didTestDataExport">
          Export DID Data
        </b-button>
      </template>
    </ffd-modal>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="modalFfd=false" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>
  <processing-view :processing="processing"></processing-view>
</div>